import React, { useEffect, useState } from 'react';
import { Navigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { PrivateLayout } from '../layout/private/PrivateLayout';
import { checkRefreshToken } from '../redux/actions/user';

export const PrivateRoute = ({ children }) => {
    const dispatch = useDispatch();
    const { isAuthenticated, loadingRefreshToken } = useSelector((state) => state.user);
    const [isCheckingAuth, setIsCheckingAuth] = useState(!isAuthenticated);

    // console.log('PrivateRoute');
    // console.log('isAuthenticated PrivateRoute', isAuthenticated);

    useEffect(() => {
        const checkTokenValidity = async () => {
            // Solo verificar si no está autenticado
            if (!isAuthenticated && !loadingRefreshToken) {
                const status = await dispatch(checkRefreshToken());
                // console.log('checkRefreshToken status:', status);
            }
            setIsCheckingAuth(false);
        };
        
        // Solo verificar al montar el componente si no está autenticado
        if (!isAuthenticated) {
            checkTokenValidity();
        } else {
            setIsCheckingAuth(false);
        }
    }, []); // Dependencias vacías para ejecutar solo una vez

    // Muestra un loader mientras se verifica el token
    if (isCheckingAuth || loadingRefreshToken) {
        return (
            <div className="flex justify-center items-center h-screen bg-white/25">
                <div className="relative inline-flex">
                    <div className="w-16 h-16 bg-indigo-500 rounded-full"></div>
                    <div className="w-16 h-16 bg-indigo-600 rounded-full absolute top-0 left-0 animate-ping"></div>
                    <div className="w-16 h-16 bg-indigo-600 rounded-full absolute top-0 left-0 animate-pulse"></div>
                </div>
            </div>
        )
    }

    if (isAuthenticated) {
        return (
            <PrivateLayout>
                {children}
            </PrivateLayout>
        );
    }

    // console.log('Usuario no autenticado, redirigiendo a login');
    return <Navigate to="/login" replace />;
};


